import React from 'react';
import { IconContainer } from './IconContainer';

const ArrowBackIcon = (props) => {
    return (
        <IconContainer ariaLabel="arrow-back" cursor="pointer" { ...props }>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.828 11.9998L14.657 14.8278L13.243 16.2428L9 11.9998L13.243 7.75684L14.657 9.17184L11.828 11.9998Z" fill="#8898B2"/>
            </svg>
        </IconContainer>
    )
}

export { ArrowBackIcon };